package com.milta.core.localization.translations.fr

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Adresse de chargement",
    emptyMessage = "Pour optimiser la tournée, indiquez où vos chauffeurs chargent les marchandises. Elle sera enregistrée pour vos prochaines tournées.",
    selectPlaceholder = "Choisir une adresse de chargement",
    sheetSubtitle = "Là où vos chauffeurs prennent les marchandises.",
    startPointBadge = "Point de départ",
    newAddressAction = "Nouvelle adresse",
    mobileSearchPlaceholder = "Rue, numéro, commune",
    webSearchPlaceholder = "Rechercher une adresse…",
    deleteDialogTitle = "Supprimer cette adresse ?",
    deleteDialogMessage = "« %s » ne sera plus proposée. Les tournées déjà créées ne changent pas.",
    webSubmitBlockedHint = "Choisissez une adresse de chargement pour optimiser.",
    errorRequired = "Choisissez une adresse de chargement.",
)
